module.exports = __webpack_public_path__ + "img/2@3x.7b2a1251.png";